import Vue from 'vue'
import Vuex from 'vuex'

import { FeathersVuex } from '@/api-client'
import auth from './store.auth'

Vue.use(Vuex)
Vue.use(FeathersVuex)

Vue.config.devtools = true

const requireModule = require.context(
  // The path where the service modules live
  './services',
  // Whether to look in subfolders
  true,
  // Only include .js files (prevents duplicate imports`)
  /.js$/
)
const servicePlugins = requireModule
  .keys()
  .map(modulePath => requireModule(modulePath).default)

const state = () => ({
  snack: '',
  successSnack: '',
  errorSnack: '',
  additionalItems: [],
  additionalItemsFocused: false
})

const mutations = {
  setSnack (state, snack) {
    state.snack = snack
  },
  setSuccessSnack (state, snack) {
    state.successSnack = snack
  },
  setErrorSnack (state, snack) {
    state.errorSnack = snack
  },
  ADD_ITEM (state, item) {
    state.additionalItems.unshift({
      value: item.value,
      quantity: item.quantity || 1,
      imageUrl: item.imageUrl || null
    })
  },
  UPDATE_ITEM (state, { index, value }) {
    state.additionalItems.splice(index, 1, value)
  },
  REMOVE_ITEM (state, index) {
    state.additionalItems.splice(index, 1)
  },
  UPDATE_ITEM_IMAGE (state, { index, imageUrl }) {
    const item = state.additionalItems[index]
    if (item) {
      item.imageUrl = imageUrl
    }
  },
  SET_ADDITIONAL_ITEMS_FOCUSED (state, focused) {
    state.additionalItemsFocused = focused
  },
  CLEAR_ADDITIONAL_ITEMS (state) {
    state.additionalItems = []
  }
}

export default new Vuex.Store({
  mutations,
  state,
  plugins: [...servicePlugins, auth]
})
